import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import type { IMetaPage, MetaIntegration } from '@feathr/blackbox';

import MetaConnectionOverview from './MetaConnectionOverview';
import MetaCreateCampaignCard from './MetaCreateCampaignCard';

interface IMetaConnectedViewProps {
  integration: MetaIntegration | null;
  pages: IMetaPage[];
}

function MetaConnectedView({ integration, pages }: Readonly<IMetaConnectedViewProps>): JSX.Element {
  const theme = useMantineTheme();

  return (
    <Stack gap={theme.spacing[8]}>
      <MetaCreateCampaignCard disabled={!integration?.isConnected} />
      <MetaConnectionOverview integration={integration} pages={pages} />
    </Stack>
  );
}

export default MetaConnectedView;
